/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：システム定数
 *
 * 作成者：2021/11/19 ノア）黄
 * 最終修正者：2021/11/30 ノア）黄
 *
 */

/**
 * マスタデータの最大件数
 *
 * @readonly
 * @constant
 */
export const MaxDataCount = 1000

/**
 * CSVファイルの最大サイズ(MB)
 *
 * @readonly
 * @constant
 */
export const MaxFileSize = 3

/**
 * 本社コード
 *
 * @readonly
 * @constant
 */
export const MainOfficeCode = '00000000'

/**
 * 機能一覧
 *
 * @readonly
 * @constant
 */
export const ScreenListMenuId = 'screenList'

/**
 * 会社とユーザのハイフォン
 *
 * @readonly
 * @constant
 */
export const SymbolsBetweenCompanyAndUser = '-'

/**
 * 受信回数カウントタイプ
 *
 * @readonly
 * @constant
 */
export enum TrustedRepliesCountType {
  /**
   * 日別
   */
  DAY = '0',
  /**
   * 月別
   */
  MONTH = '1'
}

/**
 * マスタ取得タイプ
 *
 * @readonly
 * @constant
 */
export enum MasterType {
  /**
   * 詳細検索
   */
  DETAIL = '0',
  /**
   * 簡略検索
   */
  SIMPLE = '1'
}

/**
 * データ取得タイプ
 *
 * @readonly
 * @constant
 */
export enum DeleteType {
  /**
   * 削除されていないデータの取得
   */
  notdeleteData = '0',
  /**
   * 削除されたデータの取得
   */
  deleteData = '1'
}

/**
 * データ操作タイプ定義
 *
 * @readonly
 * @constant
 */
export enum OperationDivision {
  /**
   * 追加
   */
  INSERT = 'insert',
  /**
   * 削除
   */
  DELETE = 'delete'
}

/**
 * ページタイプ
 *
 * @readonly
 * @constant
 */
export enum PageType {
  /**
   * 空
   */
  NOPAGE = 'noPage',
  /**
   * ページ
   */
  PAGE = 'page',
  /**
   * ポップアップ
   */
  POPUP = 'popup'
}

/**
 * 分析区分
 *
 * @readonly
 * @constant
 */
export enum AnalysisDivision {
  /**
   * グラフ
   */
  GRAHP = 'grahp',
  /**
   * テーブル
   */
  TABLE = 'table'
}

/**
 * 点検整備時期閾値
 *
 * @readonly
 * @constant
 */
export enum MaintenanceWarningDays {
  /**
   * 黄色の警告期間
   */
  YELLOW_WARNING_DAYS = 45,

  /**
   * 赤色の警告期間
   */
  RED_WARNING_DAYS = 30
}

/**
 * 車検時期閾値
 *
 * @readonly
 * @constant
 */
export enum CheckCarWarningDays {
  /**
   * 黄色の警告期間
   */
  YELLOW_WARNING_DAYS = 60,

  /**
   * 赤色の警告期間
   */
  RED_WARNING_DAYS = 30
}

/**
 * 通知タイプ
 *
 * @readonly
 * @constant
 */
export enum NotificationsType {
  /**
   * すべて
   */
  ALL = '0',

  /**
   * 違反
   */
  VIOLATION = '1',

  /**
   * 温度異常
   */
  TEMPERATURE_ANOMALY = '2'
}

/**
 * 通知タイプ
 *
 * @readonly
 * @constant
 */
export enum AnnounceType {
  /**
   * すべて
   */
  ALL = '0',

  /**
   * 未読
   */
  UNREAD = '1',

  /**
   * 社内
   */
  COMPANY = '2',

  /**
   * 所属営業所
   */
  BUSINESS_OFFICE = '3'
}

/**
 * メッセージ送信タイプ
 *
 * @readonly
 * @constant
 */
export enum MessageSendListType {
  /**
   * 送信履历
   */
  HISTORY = '1',

  /**
   * 予約
   */
  RESERVATION = '0'
}

/**
 * メッセージ送信タイプ
 *
 * @readonly
 * @constant
 */
export enum MessageSendType {
  /**
   * 即時送信
   */
  IMMEDIATE = '0',

  /**
   * 時間指定
   */
  TIME_SPECIFICATION = '1'
}

/**
 * メッセージタイプ
 *
 * @readonly
 * @constant
 */
export enum MessageType {
  /**
   * 回答不要
   */
  ANSWER_UNNECESSARY = '1',

  /**
   * 回答要求
   */
  ANSWER_REQUEST = '2',

  /**
   * 数値回答
   */
  NUMERIC_ANSWER = '3'
}

/**
 * 送信状況
 *
 * @readonly
 * @constant
 */
export enum SendStatus {
  /**
   * 送信依頼
   */
  REQUEST = '0',

  /**
   * 送信失敗
   */
  FAILURE = '1',

  /**
   * 送信成功
   */
  SUCCESS = '2'
}

/**
 * ユーザ種類
 *
 * @readonly
 * @constant
 */
export enum UserRole {
  /**
   * システム
   */
  SYSTEM = '0',

  /**
   * 運用者
   */
  USER = '1',

  /**
   * TOOL管理権限
   */
  TOOL_ADMIN = '3',

  /**
   * API連携
   */
  API_CONNECT = '4'
}

/**
 * ユーザー権利種類
 *
 * @readonly
 * @constant
 */
export enum AdminFlgType {
  /**
   * システム
   */
  SYSTEM = '1',

  /**
   * 運用者
   */
  USER = '0'
}

/**
 * ユーザ種類
 *
 * @readonly
 * @constant
 */
export enum PlaceType {
  /**
   * 普通場所
   */
  COMMON = '0',

  /**
   * ヤード
   */
  YARD = '1'
}

/**
 * 節電モード種類
 *
 * @readonly
 * @constant
 */
export enum PowerType {
  /**
   * 通常モード
   */
  COMMON = '0',

  /**
   * 3か月以降交換
   */
  EXCHANGE = '1',

  /**
   * 節電モード1
   */
  MODE1 = '2',

  /**
   * 節電モード2
   */
  MODE2 = '3'
}

/**
 * エリア別タイプ
 *
 * @readonly
 * @constant
 */
export enum AreaRole {
  /**
   * エリア
   */
  AREA = '0',

  /**
   * 都道府県
   */
  PREFECTURE = '1'
}

/**
 * データ種類
 *
 * @readonly
 * @constant
 */
export enum DataType {
  /**
   * 追加
   */
  INSERT = '0',

  /**
   * 変更
   */
  UPDATE = '1',

  /**
   * 削除
   */
  DELETE = '2'
}

/**
 * CSVテンプレート種類
 *
 * @readonly
 * @constant
 */
export enum TemplateCode {
  /**
   * GPSトラッカー登録
   */
  MST_GPS_TRACKER = '0',

  /**
   * トラクターヘッド登録
   */
  MST_TRACTOR_HEAD = '1',

  /**
   * 連結可能トラクターヘッド登録
   */
  MST_AVL_TRACTOR_HEAD = '2',

  /**
   * 営業所登録
   */
  MST_SALES_OFC = '3',

  /**
   * 管理対象登録
   */
  MST_MGMT_TRGTS = '4',

  /**
   * 管理場所登録
   */
  MST_MGMT_LOC = '5',

  /**
   * 管理場所詳細登録
   */
  MST_MGMT_LOC_DTLS = '6',

  /**
   * 連携会社登録
   */
  MST_CONNECT_COMPANY = '7',

  /**
   * 管理対象デジタコ連携会社登録
   */
  MST_MGMT_TRGTS_CONNECT_COMPANY = '8'
}

/**
 * お気に入り種類
 *
 * @readonly
 * @constant
 */
export enum BookmarksTargetType {
  /**
   * 営業所
   */
  SALES_OFC = '0',

  /**
   * メニュー
   */
  MENU = '1'
}

/**
 * 利用状況
 *
 * @readonly
 * @constant
 */
export enum UsageStatus {
  /**
   * 未利用
   */
  NO_USE = '0',

  /**
   * 利用中
   */
  IN_USE = '1'
}

/**
 * 稼働状況
 *
 * @readonly
 * @constant
 */
export enum DeviceStatus {
  /**
   * 電源ON
   */
  POWER_ON = '0',

  /**
   * 停止検知
   */
  STOP_DETECTION = '1',

  /**
   * 稼働開始
   */
  START_OPERATION = '2',

  /**
   * 電源OFF
   */
  POWER_OFF = '3',

  /**
   * 停止中定期
   */
  PERIODIC_OUTAGE = '4',

  /**
   * 稼働中定期
   */
  PERIODIC_DURING_OPERATION = '5'
}

/**
 * 加速度検知閾値レンジ
 *
 * @readonly
 * @constant
 */
export enum ThresholdRange {
  /**
   * ±2G
   */
  G2 = '0',

  /**
   * ±4G
   */
  G4 = '1',

  /**
   * ±8G
   */
  G8 = '2'
}

/**
 * 管理対象割当種類
 *
 * @readonly
 * @constant
 */
export enum ManagementAllocType {
  /**
   * 営業所
   */
  BUSINESS_OFFICE = 'BUSINESS_OFFICE',

  /**
   * 管理対象
   */
  MANAGEMENT_TARGET = 'MANAGEMENT_TARGET'
}

/**
 * アップロードできる画像の種類
 */
export const AllowedImgType = ['image/jpeg', 'image/png', 'image/jpg']

/**
 * 営業所割当種類
 *
 * @readonly
 * @constant
 */
export enum OfficeAllocType {
  /**
   * 営業所
   */
  BUSINESS_OFFICE = 'BUSINESS_OFFICE',

  /**
   * 未割当
   */
  UN_ALLOC = 'UN_ALLOC'
}

/**
 * アップロードされた画像の最大サイズ
 *
 * @readonly
 * @constant
 */
export const MaxImgSize = 2 * 1024 * 1024

/**
 * アップロードされた画像の最小の幅と高さ
 *
 * @readonly
 * @constant
 */
export const MinImage = {
  Width: 800,
  Height: 480
}

/**
 * メニューID
 *
 * @readonly
 * @constant
 */
export enum MenuIds {
  /**
   * 移動実績
   */
  MIGRATION_RESULT = 'migrationResult',
  /**
   * マスタ
   */
  MASTER = 'master'
}

/**
 * 画像アップロードAPIタイプ
 *
 * @readonly
 * @constant
 */
export const UploadApiType = {
  /**
   * 管理場所詳細画像アップロード
   */
  placeImg: 'PLACE',

  /**
   * 管理場所詳細画像アップロード
   */
  placeDtlImg: 'PLACE_DTL'
}

/**
 * MIMEタイプ
 *
 * @readonly
 * @constant
 */
export const MIMEType = {
  /**
   * csv
   */
  csv: 'text/csv',
  /**
   * pdf
   */
  pdf: 'application/pdf',
  /**
   * zip
   */
  zip: 'application/zip'
}

/**
 * 対象種類
 *
 * @readonly
 * @constant
 */
export enum SelectType {
  /**
   * すべて
   */
  all = '0',
  /**
   * 受信回数を超えるのみ
   */
  overFlag = '1'
}

/**
 * クッキーのキー
 *
 * @readonly
 * @constant
 */
export const AccessToken = 'ACCESS_TOKEN'

/**
 * MFA検証フラグ
 *
 * @readonly
 * @constant
 */
export enum MFAFlag {
  /**
   * MFA検証有効フラグ
   */
  MFA_VALID_FLAG = '1',
  /**
   * MFA検証無効フラグ
   */
  MFA_INVALID_FLAG = '0'
}

/**
 * MFAバインドフラグフラグ
 *
 * @readonly
 * @constant
 */
export enum MFABindFlag {
  /**
   *  MFAバインドフラグ有効フラグ
   */
  MFA_BIND_FLAG = '1',
  /**
   * MFAバインドフラグ無効フラグ
   */
  MFA_UNBIND_FLAGE = '0'
}

/**
 * 管理対象移動履歴の種類
 *
 * @readonly
 * @constant
 */
export enum ManagementTargetHistoryType {
  /**
   * 都道府県内
   */
  IN_TARGET = '0',
  /**
   * 利用可能エリア内
   */
  OUTSIDE_BUT_IN_ALLOWED_AREA = '1',
  /**
   * 利用可能エリア外
   */
  OUTSIDE = '2'
}

/**
 * 帳票選択の種類
 *
 * @readonly
 * @constant
 */
export enum BillSelectType {
  /**
   * 指示日時管理
   */
  Appoint_Time = '0',
  /**
   * 一定期間停止管理
   */
  Period_Stop = '1'
}

/**
 * 汎用定義 稼働中定期タイマｍ,nの値のフラグ
 *
 * @readonly
 * @constant
 */
export enum OptPeriodTimerConfig {
  /**
   * デフォルト設定
   */
  OPT_PERIOD_TIMER_0 = '0',
  /**
   * senk会社の設定
   */
  OPT_PERIOD_TIMER_1 = '1'
}

/**
 * 稼働中定期 プルダウンのキー
 *
 * @readonly
 * @constant
 */
export enum RunningRegularTimerSettingValues {
  /**
   * 稼働中定期通信 分後
   */
  RUNNING_REGULAR_TIMER_VALUE_SETTING = '0',
  /**
   *  稼働中定期通信 分周期
   */
  RUNNING_REGULAR_TIMER_MINUTES_VALUE_SETTING = '1'
}

/**
 * 復旧対象
 *
 * @readonly
 * @constant
 */
export enum ToolDataRecoveryObj {
  /**
   * 会社に所属全端末
   */
  ALL = '1',
  /**
   * SigfoxID
   */
  SIGFOXID = '2'
}

/**
 * 実行状態
 *
 * @readonly
 * @constant
 */
export enum ToolDataRecoveryActionStatus {
  /**
   * 成功
   */
  SUCCESS = '0',
  /**
   * 失敗
   */
  FAILURE = '1'
}

/**
 * 公開対象
 *
 * @readonly
 * @constant
 */
export enum ToolAnnouncementPublicTarget {
  /**
   * ログイン画面
   */
  LOGIN = '1',
  /**
   * 全会社
   */
  ALL = '2',
  /**
   * 会社
   */
  COMPANY = '3'
}

/**
 * 公開フラグ
 *
 * @readonly
 * @constant
 */
export enum ToolAnnouncementPublicFlag {
  /**
   * 未公開
   */
  NOT_PUBLIC = '0',
  /**
   * 公開
   */
  PUBLIC = '1'
}
